import { getApi } from '../utils/api'

export function getChatCounters() {
  return getApi({ endpoint: 'idwell-api/api/v3/chat/chats/counters/' })
}

export function getCommonCounters() {
  return getApi({
    endpoint: 'api/profile/counters/',
    params: { is_redesign_context: 1 },
  })
}

export function getNewsboardCounters() {
  return getApi({ endpoint: 'idwell-api/api/v3/news/posts/counters/' })
}
